import {DatetimeUtils} from "./datetime-utils";
import {BaseUtils} from "./base-utils";
import _differenceInMilliseconds from 'date-fns/differenceInMilliseconds';

class CountdownUtils extends BaseUtils {
  countdownIntervalId;
  datetimeUtils: DatetimeUtils;

  static injectables = [...BaseUtils.injectables, DatetimeUtils]

  constructor(datetimeUtils: DatetimeUtils) {
    super();

    this.countdownIntervalId = null;
  }

  startCountdown(datetime, intervalTime, callback) {
    this.stopCountdown();

    callback(this.getCountdown(datetime));
    this.countdownIntervalId = setInterval(() => {
      callback(this.getCountdown(datetime));
    }, intervalTime);
  }

  stopCountdown() {
    clearInterval(this.countdownIntervalId);
  }

  getCountdown(datetime: Date): String {
    const currentDate: Date = new Date();
    const diffTime: Number = _differenceInMilliseconds(datetime, currentDate);
    const duration: String = this._duration(diffTime);

    return duration;
  }

  _duration(milliseconds): String {
    if (milliseconds < 0) {
      return;
    }

    const dayInMs = 86400000;
    const hourInMs = 3600000;
    const minuteInMs = 60000;

    const day = milliseconds / dayInMs >= 1 ? parseInt(milliseconds / dayInMs, 10) : 0;
    if (day >= 3) {
      milliseconds -= dayInMs * day;
    }
    const hour = milliseconds / hourInMs >= 1 ? parseInt(milliseconds / hourInMs, 10) : 0;
    if (hour >= 1) {
      milliseconds -= hourInMs * hour;
    }

    const min = milliseconds / minuteInMs >= 1 ? parseInt(milliseconds / minuteInMs, 10) : 0;
    if (min >= 1) {
      milliseconds -= minuteInMs * min;
    }
    const sec = parseInt(milliseconds / 1000, 10);

    return `${('' + hour).padStart(2, '0')}:${('' + min).padStart(2, '0')}:${('' + sec).padStart(2, '0')}`;
  }
}

export const countdownHelper = new CountdownUtils();
